export class IndexDbService {
    constructor(id) {
        this.DB_NAME = 'ds_inputs_v1.2';
        this.DB_VERSION = 1;
        this.STORE_NAME = 'inputs';
        this.id = id || '';
        this.db = null;
    }

    async openDb() {
        try {
            if (this.db) return this.db;

            return new Promise((resolve) => {
                const request = indexedDB.open(this.DB_NAME, this.DB_VERSION);
                if (!request) {
                    return resolve();
                }
                request.onupgradeneeded = (event) => {
                    const db = event.target.result;
                    if (!db.objectStoreNames.contains(this.STORE_NAME)) {
                        const store = db.createObjectStore(this.STORE_NAME, { keyPath: 'elementId', unique: true });
                        store?.createIndex('tempId', 'tempId', { unique: false });
                    }
                    resolve();
                };
                request.onsuccess = (event) => {
                    this.db = event.target.result;
                    this.db.onclose = () => {
                        this.db = null;
                    };
                    resolve(this.db);
                };
                request.onerror = () => {
                    console.error('indexDb not supported by browser. Test value on elements will not be saved');
                    resolve();
                };
            });
        } catch {
            console.error('indexDb not supported by browser. Test value on elements will not be saved');
        }
    }

    async getStore(mode = 'readonly') {
        try {
            const db = await this.openDb();
            return db?.transaction(this.STORE_NAME, mode)?.objectStore(this.STORE_NAME);
        } catch (error) {
            console.error('indexDb error:', error);
        }
    }

    async getEpsValues(tempId) {
        try {
            return new Promise(async (resolve) => {
                const store = await this.getStore('readonly');
                const index = store?.index('tempId');
                const request = index?.getAll(IDBKeyRange.only(tempId));
                if (!request) {
                    return resolve();
                }
                request.onsuccess = () => resolve(request.result);
            });
        } catch (error) {
            console.error('indexDb error:', error);
        }
    }

    async saveValues(newTempId, listIds) {
        try {
            const store = await this.getStore('readwrite');
            const index = store?.index('tempId');

            return new Promise((resolve) => {
                const request = index?.getAll(IDBKeyRange.only(newTempId));
                let filteredList = listIds;
                if (!request) {
                    return resolve();
                }
                request.onsuccess = () => {
                    if (request.result && request.result?.length) {
                        filteredList = listIds.filter(
                            (objToSave) => !request.result.map((a) => a.elementId).includes(objToSave.uuid)
                        );
                    }
                    filteredList.forEach((elemet) => {
                        store.put({ elementId: elemet.uuid, value: elemet.value, tempId: newTempId });
                    });
                };
            });
        } catch (error) {
            console.error('indexDb error:', error);
        }
    }

    async findAndEditValue(id, value) {
        try {
            const store = await this.getStore('readwrite');

            return new Promise((resolve) => {
                const request = store?.get(id);
                if (!request) {
                    return resolve();
                }
                request.onsuccess = () => {
                    const data = request.result;
                    if (data) {
                        data.value = value;
                        store.put(data);
                        resolve(data);
                    }
                };
            });
        } catch (error) {
            console.error('indexDb error:', error);
        }
    }
}
